export default {
      id: "globe-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#globe",
      toString: function () {
        return this.url;
      }
    }